export default {
  'app.pwa.offline': 'Ahora estás sin conexión',
  'app.pwa.serviceworker.updated': 'Nuevo contenido disponible',
  'app.pwa.serviceworker.updated.hint':
    'Pulsa el botón "Actualizar" para recargar la página actual',
  'app.pwa.serviceworker.updated.ok': 'Actualizar',
};